import styled from "styled-components";
import { FlexContainer } from "src/affiliate/styled/layout.styled";

export const StyledFlexContainer = styled(FlexContainer)`
    width: 100%;
    border-radius: 4px;
    background-color: #1a0949;
    flex-direction: column;
    margin: 20px 0 0 0;
`;